import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const Payroll = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">Payroll Software</h1>
                <p className="colorWht">GPayroll is a payroll software designed with simplicity in mind.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="content-dest">
          <div className="col-lg-12 content-dest-bg">
            <div className="col-lg-5 col-md-5 col-sm-6 padTB58 text-right">
              <img src="/images/payroll.jpg" alt="payroll" className="content-img" />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 padTB58 padLR15">
              <p>
                Green Orange's GPayroll is a payroll software designed with simplicity in mind. Our GPayroll provides complete payroll processing system with comprehensive solutions to help manage your business better.
              </p>
              <p>
                An integrated Payroll within your TMS Software will save you enormous number of hours required to generate payslips for your employees. GPayroll helps you comply with legal and tax requirements and simplifies the process of paying your employees. With GPayroll - you never need to outsource your Payroll to a third party vendor.
              </p>
              <p>GPayroll supports both monthly salary and hourly wages structure.</p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 bgwhite">
              <div className="dest-rightside">
                <div>You may also be interested in <span> our other products</span></div>
                <ul className="pad0">
                  <li><Link to="/transport-management-system" title="Transport Management System">Transport Management System</Link></li>
                  <li><Link to="/gps-tracking-software" title="GPS Tracking as Software">GPS Tracking as Software</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h2>Why Choose GPayroll?</h2>
                <ul className="">
                  <li>Complete payroll processing system with comprehensive solutions</li>
                  <li>Compliance with legal and tax requirements</li>
                  <li>Simplified process of paying your employees</li>
                  <li>No need to outsource Payroll to third party vendors</li>
                  <li>Supports both monthly salary and hourly wages structure</li>
                  <li>Integrated with TMS Software for seamless operations</li>
                  <li>Automated payslip generation saves time and reduces errors</li>
                  <li>EPF, PCB, and SOCSO calculations included</li>
                </ul>
                <h3>Key Features</h3>
                <h4>Payroll Processing</h4>
                <ul>
                  <li>Automated salary calculations</li>
                  <li>Monthly and hourly wage support</li>
                  <li>Overtime and bonus calculations</li>
                  <li>Deduction management (loans, advances, etc.)</li>
                  <li>Multiple pay structures support</li>
                </ul>
                <h4>Tax & Compliance</h4>
                <ul>
                  <li>EPF (Employee Provident Fund) calculations</li>
                  <li>PCB (Pay As You Earn) tax calculations</li>
                  <li>SOCSO calculations</li>
                  <li>Automatic tax deduction</li>
                  <li>Compliance with local tax regulations</li>
                </ul>
                <h4>Time & Attendance Integration</h4>
                <p>
                  GPayroll seamlessly integrates with time and attendance systems. A comprehensive and integrated time management module enables employees to record their arrival, departure, lunch break in and out and additional break in and out. This provides managers with detailed information about attendance records, absenteeism, overtime etc.
                </p>
                <p>
                  GreenOrange offers seamless integration with most biometrics devices, making it easy for you to use your existing finger scan / card reader device to capture your attendance data and migrate it into GPayroll.
                </p>
                <h4>Reports & Management</h4>
                <ul>
                  <li>Payslip generation and management</li>
                  <li>Payroll summary reports</li>
                  <li>Tax reports and statements</li>
                  <li>Employee attendance reports</li>
                  <li>Customizable reporting options</li>
                </ul>
                <h3>Benefits</h3>
                <ul>
                  <li><strong>Time Savings:</strong> Automate payroll processing and save enormous hours required for manual calculations</li>
                  <li><strong>Accuracy:</strong> Reduce errors with automated calculations and compliance checks</li>
                  <li><strong>Cost Effective:</strong> Eliminate the need for third-party payroll vendors</li>
                  <li><strong>Compliance:</strong> Stay compliant with legal and tax requirements automatically</li>
                  <li><strong>Integration:</strong> Seamlessly integrate with TMS and other business systems</li>
                  <li><strong>Scalability:</strong> Handle payroll for small to large organizations</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default Payroll;

